import { createStore } from 'vuex';
import app from './app';
import companies from './companies';
import indications from './indications';
import jobs from './jobs';
import person from './person';
import user from './user';

export default createStore({
  modules: {
    app,
    companies,
    indications,
    jobs,
    person,
    user,
  },
});
